"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This function returns formatted string as an array, specifically so React can
 * render it (it can handle a mixed array of strings and JSX). This allows us to
 * format strings with React components, which is the correct thing to do with
 * accessibility (for RTL).
 */
function formatToArray(template) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    // Regex that finds {#} so it can be replaced by the arguments in string format.
    var FORMAT_REGEX = /\{(\d+)\}/g;
    var parts = [];
    var regexResult;
    var lastIndex = 0;
    while ((regexResult = FORMAT_REGEX.exec(template))) {
        // The full string of characters matched.
        var match = regexResult[0];
        // Get replacement value.
        var valueIndex = parseInt(match.replace(/\{|\}+/g, ""), 10);
        var replacementValue = values[valueIndex];
        // Get text between tokens and add to our array.
        if (regexResult.index > lastIndex) {
            parts.push(template.substring(lastIndex, regexResult.index));
        }
        // Save last index.
        lastIndex = FORMAT_REGEX.lastIndex;
        // Add replacement value to our array.
        parts.push(replacementValue);
    }
    // Grab any remaining text after the last match.
    if (lastIndex !== template.length) {
        parts.push(template.substring(lastIndex, template.length));
    }
    return parts;
}
exports.default = formatToArray;
